// eslint-disable-next-line import/no-unresolved
import { reject } from 'lodash'

import i18n from '@/i18n/i18n'
import { BlacklistService } from '@/services/admin/BlacklistService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const allowedFilters = ['tckn']
export const allowedIncludes = ['farmer:id,tckn,address_id', 'retailer:id,vkn', 'createdActivity:activist_id,activist_type,subject_id,subject_type,created_at']
export const allowedAppends = ['subject_type']
export const allowedSorts = '-id'

export const state = {
  blacklists: [],
  blacklist: {},
  meta: null
}

export const mutations = {
  SET_BLACKLISTS(state, blacklists) {
    state.blacklists = blacklists.data
    state.meta = blacklists.meta
  },
  SET_BLACKLIST(state, blacklist) {
    state.blacklist = blacklist
  },
  ADD_BLACKLIST(state, blacklist) {
    state.blacklists.unshift(blacklist)
  },
  DELETE_BLACKLIST(state, blacklistToRemove) {
    state.blacklists = state.blacklists.filter(blacklist => {
      return blacklist.id !== blacklistToRemove.id
    })
  }
}

export const actions = {
  getBlacklists({ commit }, query) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts, allowedAppends)
    return new Promise(resolve => {
      let blacklistService = new BlacklistService(newQuery)
      blacklistService.getBlacklists().then(response => {
        commit('SET_BLACKLISTS', response)
        resolve(response.data)
      })
    })
  },
  getBlacklist({ commit }, id) {
    return new Promise(resolve => {
      let blacklistService = new BlacklistService()
      blacklistService.getBlacklist(id).then(response => {
        commit('SET_BLACKLIST', response.data)
        resolve(response.data)
      })
    })
  },
  createBlacklist({ commit, dispatch }, blacklist) {
    return new Promise(resolve => {
      let blacklistService = new BlacklistService()
      blacklistService
        .createBlacklist(blacklist)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.added', {
              element: t('store.admin.blacklist.to_blacklist')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          commit('ADD_BLACKLIST', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.adding_problem', {
                element: t('store.admin.blacklist.to_blacklist')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateBlacklist({ state, dispatch }, blacklist) {
    return new Promise(resolve => {
      let blacklistService = new BlacklistService()
      blacklistService.updateBlacklist(state.blacklist.id, blacklist).then(response => {
        const notification = {
          type: 'success',
          message: t('store.shared.updated', {
            element: t('store.admin.blacklist.blacklist')
          })
        }
        dispatch('notification/add', notification, {
          root: true
        })
        resolve(response.data)
      })
    })
  },
  destroyBlacklist({ commit, dispatch }, blacklist) {
    return new Promise(resolve => {
      let blacklistService = new BlacklistService()
      blacklistService
        .destroyBlacklist(blacklist.id, blacklist.removal_reason)
        .then(response => {
          let notification = {}

          if (response.data.waitingApproval === true) {
            notification = {
              type: 'warning',
              message: t('store.shared.waiting_approval', {
                element: t('store.admin.blacklist.from_blacklist')
              })
            }
          } else {
            commit('DELETE_BLACKLIST', blacklist)
            notification = {
              type: 'warning',
              message: t('store.shared.deleted', {
                element: t('store.admin.blacklist.from_blacklist')
              })
            }
          }

          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
